import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=10675c90&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=10675c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10675c90",
  null
  
)

export default component.exports